import styled from 'styled-components';
import UgcPersuatiosIconSvg from '../assets/ugc-persuasion.svg';

const UgcPersuasionIcon = styled(UgcPersuatiosIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  cursor: pointer;
  g {
    path:last-child {
      fill: ${props => props.fill};
    }
  }
`;

export default UgcPersuasionIcon;
